// import Swiper from 'swiper'
// import { Autoplay, Controller, EffectFade, Navigation, Pagination } from 'swiper/modules'
// Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

import Delta from './module/utils/_delta'

Number.prototype.clamp = function (min, max) {
  return Math.min(Math.max(this, min), max)
}

/**
 * fixNav
 */
const fixNav = document.querySelector('.fixNav')
const fixNavClose = document.querySelector('.fixNav__close')
fixNavClose.addEventListener('click', () => {
  fixNav.classList.add('hide')
})

/**
 * mv
 */
const mvSlides = document.querySelectorAll('.mv__slide')
if (mvSlides.length) {
  const delta = new Delta()

  let progress = 0
  const maxProgress = mvSlides.length
  const speed = 0.002

  const update = () => {
    const dt = delta.getDelta(true)

    progress += speed * dt
    if (progress >= maxProgress) {
      progress -= maxProgress
    }

    const nowIdx = Math.floor(progress)
    const nextIdx = (nowIdx + 1) % maxProgress

    const ratio = progress - nowIdx
    const scaleRatio = ((ratio - 0.1) / 0.9).clamp(0, 1)
    const fadeRatio = ((ratio - 0.9) / 0.1).clamp(0, 1)

    mvSlides.forEach((slide, index) => {
      if (index == nowIdx) {
        slide.style.zIndex = 2
        slide.style.scale = 1 + 0.1 * scaleRatio
        slide.style.opacity = 1 - fadeRatio
      } else {
        if (index == nextIdx) {
          slide.style.zIndex = 1
        } else {
          slide.style.zIndex = 0
        }

        slide.style.scale = ''
        slide.style.opacity = ''
      }
    })

    requestAnimationFrame(update)
  }

  setTimeout(() => {
    update()
  }, 1000)
}

// const nextMvSlide = () => {
//   const currentIndex = [...mvSlides].findIndex((slide) => slide.classList.contains('active'))
//   const nextIndex = currentIndex + 1 < mvSlides.length ? currentIndex + 1 : 0

//   mvSlides[currentIndex]?.classList.remove('active')
//   mvSlides[nextIndex].classList.add('active')
// }
// setInterval(nextMvSlide, 5000)

const mvAnime = document.querySelectorAll('#mv .anime')
mvAnime.forEach((anime) => {
  anime.classList.add('animated')
})

/**
 * side / results 横スライド
 */
const AUTO_SLIDE_SPEED = 40 // px/sec

const createAutoSlideStates = (slides) =>
  [...slides].map((el, index) => ({
    el,
    offset: 0,
    direction: index === 1 ? 1 : -1, // 2つ目だけ逆方向
    ready: false,
  }))

const autoSlideStates = [
  ...createAutoSlideStates(document.querySelectorAll('.side__slide')),
  ...createAutoSlideStates(document.querySelectorAll('.results__slide')),
]

let autoSlideLastTime = performance.now()

const adjustAutoSlider = (now = performance.now()) => {
  const delta = Math.min(now - autoSlideLastTime, 64)
  autoSlideLastTime = now

  for (const state of autoSlideStates) {
    const half = state.el.scrollWidth / 2
    if (!half) continue

    // 逆方向は半分ずらした位置から開始し、左端が途切れないようにする
    if (!state.ready) {
      state.offset = state.direction > 0 ? -half : 0
      state.ready = true
    }

    state.offset += state.direction * AUTO_SLIDE_SPEED * (delta / 1000)

    if (state.direction < 0) {
      if (state.offset <= -half) state.offset += half
    } else if (state.offset >= 0) {
      state.offset -= half
    }

    state.el.style.transform = `translate3d(${state.offset}px, 0, 0)`
  }

  requestAnimationFrame(adjustAutoSlider)
}
adjustAutoSlider()
